import { ThemeEvents } from '@theme/events';
import { replayClass } from '@theme/utilities';

/**
 * Cart item count in the header. Follows CartUpdateEvent: updates its text and `data-cart-count`,
 * toggles `is-hidden` at 0 and replays the `is-bump` animation when the count grows.
 *
 * Markup: `<cart-count class="cart-count" data-cart-count="{{ cart.item_count }}">{{ cart.item_count }}</cart-count>`
 */
class CartCount extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  /** @param {number} count */
  render(count) {
    const previous = Number(this.dataset.cartCount || 0);
    this.textContent = String(count);
    this.dataset.cartCount = String(count);
    this.classList.toggle('is-hidden', !count);
    if (count > previous) replayClass(this, 'is-bump');
  }

  /** @param {Event} event */
  #onCartUpdate = (event) => {
    if (!(event instanceof CustomEvent)) return;
    const count = event.detail?.itemCount;
    if (typeof count === 'number') this.render(count);
  };
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount);
}
